import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import {persistor, store} from "./redux/store"
import { PersistGate } from 'redux-persist/integration/react';
import { createRoot } from "react-dom/client";
import { HashRouter } from "react-router-dom";

//------------------new react 18-----------------------------------
const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  
  <Provider store={store}>
   
    <PersistGate loading={null} persistor={persistor}>
    
    <App />

    </PersistGate>

  </Provider>
 ,


);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
